import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react'
import { AuthProvider } from './context/AuthContext';
import { SettingsProvider } from './context/SettingsContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import FloatingPanel from './components/FloatingPanel/FloatingPanel';
import HomePage from './pages/HomePage/HomePage';
import NewsPage from './pages/NewsPage/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage/NewsDetailPage';
import LibraryPage from './pages/LibraryPage/LibraryPage';
import BookDetailPage from './pages/BookDetailPage/BookDetailPage';
import DonationsPage from './pages/DonationsPage/DonationsPage';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import AboutPage from './pages/AboutPage/AboutPage';
import ContactsPage from './pages/ContactsPage/ContactsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';
import './App.css';
console.log = console.warn = console.error = () => {};
console.info = () => {};

function App() {
  
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (event) => {
      // Используем event.code для независимости от раскладки клавиатуры (работает и на RU, и на EN)
      
      // 1. F12
      if (event.code === 'F12' || event.keyCode === 123) {
        event.preventDefault();
        return;
      }

      // 2. Ctrl + Shift + I/J/C/K (DevTools, Console)
      if (event.ctrlKey && event.shiftKey) {
        if (['KeyI', 'KeyJ', 'KeyC', 'KeyK'].includes(event.code)) {
          event.preventDefault();
          return;
        }
      }

      // 3. Ctrl + U (Исходный код)
      if (event.ctrlKey && event.code === 'KeyU') {
        event.preventDefault();
        return;
      }

      // 4. Ctrl + S (Сохранить страницу - опционально, часто просят скрыть source)
      if (event.ctrlKey && event.code === 'KeyS') {
        event.preventDefault();
        return;
      }

      // 5. Mac: Cmd + Option + I/J/C/U
      if (event.metaKey && event.altKey) {
        if (['KeyI', 'KeyJ', 'KeyC', 'KeyU'].includes(event.code)) {
          event.preventDefault();
          return;
        }
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return (
    <SettingsProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/news/:slug" element={<NewsDetailPage />} />
                <Route path="/library" element={<LibraryPage />} />
                <Route path="/library/:slug" element={<BookDetailPage />} />
                <Route path="/donations" element={<DonationsPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contacts" element={<ContactsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              </Routes>
            </main>
            <Footer />
            <FloatingPanel />
          </div>
        </Router>
      </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
